import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCmsMainMenu } from 'cmsActions.js';
import { redirect } from 'helpers/utilsHelper.js';
import { getLanguageCookie } from 'helpers/cookiesHelper.js';
import S from 'StyledCmsMenu.js';

const countryCode = process.env.MAIN_COUNTRY_CODE;

const CmsMenu = ({ subCategories, getCmsMainMenu }) => {
  const [currentPathname, setCurrentPathname] = useState(location.pathname);

  useEffect(() => {
    getCmsMainMenu(getLanguageCookie(), countryCode);
  }, []);

  const menuItems = useMemo(() => {
    return subCategories.map((category) => ({
      id: category.id.toString(),
      label: category.name,
      subMenus: category.subCategories?.map((subCategory) => ({
        id: subCategory.id.toString(),
        to: subCategory.url,
        label: subCategory.name,
        icon: subCategory.image ? <S.MenuTabIcon src={subCategory.image} alt={subCategory.name} /> : null,
      })) ?? [],
    }));
  }, [subCategories]);

  const onNavigate = (link) => {
    if (link.startsWith("https://") || link.startsWith("http://")) {
      window.location.href = link;
      return;
    }

    redirect(link);
    app.component.MainSwipeMenu.hide();
    setCurrentPathname(link);
  };

  return menuItems.map((item) => (
    <Fragment key={item.id}>
      <S.SpaceContainer>
        <S.StartSeparator></S.StartSeparator>
        <S.PartName>{item.label}</S.PartName>
        <S.EndSeparator></S.EndSeparator>
      </S.SpaceContainer>
      {item.subMenus?.map((subItem) => (
        <S.MenuTab key={subItem.id}>
          <S.MenuTabIconText>
            <S.MenuTabIconContainer>{subItem.icon}</S.MenuTabIconContainer>
            <S.MenuTabText
              isActive={currentPathname === subItem.to}
              onClick={() => onNavigate(subItem.to)}
            >
              {subItem.label}
            </S.MenuTabText>
          </S.MenuTabIconText>
        </S.MenuTab>
      ))}
    </Fragment>
  ));
};

const mapStateToProps = ({ Cms: { subCategories } }) => {
  return {
    subCategories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCmsMainMenu: bindActionCreators(getCmsMainMenu, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsMenu);
